import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ProfileMenuContent from '@exchange/libs/account/ui/src/libs/ProfileMenuContent.vue';
import { partnersService } from '@exchange/libs/partners/service/src';

import HeaderMenu from './HeaderMenu.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PandaMenu',
  setup(__props) {

const { showPartnersDot } = partnersService;

return (_ctx: any,_cache: any) => {
  const _component_ot_icon = _resolveComponent("ot-icon")!
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createBlock(HeaderMenu, {
    class: _normalizeClass(['panda-menu', { 'show-green-dot': _unref(showPartnersDot) }]),
    "show-arrow": "show-arrow"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_x_button, {
        class: "panda-menu__user-avatar",
        variant: "tertiary",
        size: "2xs"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ot_icon, {
            class: "panda-menu__icon",
            name: "user-square"
          })
        ]),
        _: 1
      })
    ]),
    "menu-content": _withCtx(({ closeMenu }) => [
      _createVNode(ProfileMenuContent, {
        class: "panda-menu__content",
        "close-menu": closeMenu
      }, null, 8, ["close-menu"])
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})